import React from "react";
import { Button, Icon, TileOptionsButton } from "aible";

import FullPin from "images/Next-Icons/FullPin.svg";

import { TILE_TITLE_NAME } from "aible/Tile/TileTitle";

import styles from "./style.module.css";

import { Popover, OverlayTrigger } from "react-bootstrap";

const COLORS = {
  blueprint: "#4A90E2",
  project: "#7E69D7",
  deployment: "#512F77",
  red: "#C03E5A",
  green: "#54C06C",
  default: "#C8CAD4"
};

const ICONS = {
  blueprint: "blueprintWhite",
  projectSegments: "layersWhite",
  projectNoSegments: "layersNoneWhite",
  projectNoPermissions: "layersNoneWhiteGrey",
  monitoring: "monitoringWhite",
  deployment: "rocket",
  dataDefault: "database",
  dataValid: "databaseWhite",
  dataInvalid: "databaseNone"
};

export function getColor(color) {
  return COLORS[color] || color;
}

export function getIcon(icon) {
  if (typeof icon !== "string") {
    return icon;
  }
  return ICONS[icon] || icon;
}

export default class Tile extends React.Component {
  state = {
    isHover: false
  };

  handleDelete(event) {
    const { handleDelete } = this.props;

    event.stopPropagation();

    if (handleDelete) {
      return handleDelete(event);
    } else return;
  }

  handleOnClick(event) {
    const { onClick } = this.props;

    event.stopPropagation();

    if (onClick) {
      return onClick(event);
    }

    return;
  }

  render() {
    const {
      className,

      tileId,

      noHover,
      active,

      onClick,
      onClickSecond,
      onClickThird,
      secondButton,
      thirdButton,

      additionalOptions,

      // Makes the entire tile active for the onClick and hides the tile button
      isTileClick,

      // Removes the autoInjected onClick from child `TileTitle` components
      noTitleClick,

      buttonText,
      hideButton,
      showButton,

      handleDelete,
      handleMoveFolder,
      handlePin,
      isPinned,
      deleteText,
      options,
      hideOptions,
      showOptions,

      buttonOverlay,

      shouldHighlight,

      hideDelete,

      isButtonPrimary,

      children,
      ...retProps
    } = this.props;

    const retOnClick = onClick ? (e) => this.handleOnClick(e) : undefined;
    const retHandleDelete = handleDelete ? (e) => this.handleDelete(e) : undefined;

    const retNoHover = noHover || (!onClick && !handleDelete);

    // Adds the onClick for the tile to the title if it's included in the children
    const retChildren =
      noTitleClick || hideButton
        ? children
        : React.Children.map(children, (child) => {
            const currName = child && child.type && child.type.displayName;
            if (currName === TILE_TITLE_NAME && child.props && !child.props.onClick) {
              return React.cloneElement(child, { onClick: retOnClick });
            }
            return child;
          });

    return (
      <div className={styles.tileWrapper}>
        <div
          className={
            styles.tile +
            " " +
            (active ? styles.active : "") +
            " " +
            (retNoHover ? styles.noHover : "") +
            " " +
            (isTileClick && retOnClick ? styles.click : "") +
            " " +
            (className ? className : "") +
            " " +
            (shouldHighlight === false ? styles.noHighlight : "")
          }
          {...retProps}
          onClick={isTileClick ? retOnClick : undefined}
        >
          {retChildren}
          {handlePin ? (
            <Button
              className={styles.pinButton}
              active={isPinned}
              onClick={() => handlePin()}
              style={isPinned ? { padding: "6px", opacity: "1" } : { padding: "5px", top: "10px" }}
            >
              <img
                src={FullPin}
                style={{
                  height: "13px",
                  width: "13px",
                  transform: isPinned ? "none" : "rotate(45deg)"
                }}
              />
            </Button>
          ) : (
            <div />
          )}
          <TileButton
            onClick={retOnClick}
            onClickSecond={onClickSecond}
            onClickThird={onClickThird}
            buttonText={buttonText}
            secondButton={secondButton}
            thirdButton={thirdButton}
            hide={hideButton || (isTileClick && !showButton)}
            show={showButton}
            buttonOverlay={buttonOverlay}
            isButtonPrimary={isButtonPrimary}
            additionalOptions={additionalOptions}
          />
          <TileOptions
            handleDelete={retHandleDelete}
            handleMoveFolder={handleMoveFolder}
            deleteText={deleteText}
            hide={hideOptions}
            options={options}
            show={showOptions}
            hideDelete={hideDelete}
            isPinned={isPinned}
            handlePin={handlePin}
          />
        </div>
      </div>
    );
  }
}

class TileOptions extends React.PureComponent {
  render() {
    const { options, handleDelete, handleMoveFolder, deleteText, show, hide, hideDelete, handlePin, isPinned } =
      this.props;
    if (!handleDelete) {
      return <React.Fragment />;
    }
    return (
      <div
        className={styles.tileOptionsWrapper + " " + (show ? styles.show : "") + " " + (hide ? styles.hide : "")}
        style={handlePin !== undefined ? { right: "30px" } : {}}
      >
        {options}
        {handleMoveFolder ? (
          <TileOptionsButton icon={"folderPicker"} title={"Move to Other Folder"} onClick={handleMoveFolder} />
        ) : (
          ""
        )}
        {handleDelete && hideDelete !== true ? (
          <TileOptionsButton icon={"delete"} title={"Delete"} onClick={handleDelete} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export class TileButton extends React.PureComponent {
  render() {
    const {
      buttonText,
      onClick,
      onClickSecond,
      onClickThird,
      secondButton,
      thirdButton,
      show,
      hide,
      buttonOverlay,
      isButtonPrimary,
      additionalOptions
    } = this.props;

    if (!onClick || !buttonText) {
      return <React.Fragment />;
    }

    return (
      <div className={styles.tileButtonWrapper + " " + (show ? styles.show : "") + " " + (hide ? styles.hide : "")}>
        {buttonOverlay ? (
          <OverlayTrigger
            placement="top"
            trigger={buttonOverlay ? ["click"] : []}
            rootClose
            overlay={
              <Popover id="popover-positioned-top">
                <div className={styles.tileOverlay}>{buttonOverlay}</div>
              </Popover>
            }
          >
            <Button className={styles.tileButton} type={"secondary"} active>
              {buttonText}
            </Button>
          </OverlayTrigger>
        ) : (
          <Button
            onClick={hide ? undefined : onClick}
            className={styles.tileButton}
            type={isButtonPrimary ? "primary" : "secondary"}
            active
          >
            {buttonText}
          </Button>
        )}
        {secondButton ? (
          <a onClick={hide ? undefined : onClickSecond} className={styles.secondButton}>
            {secondButton}
          </a>
        ) : (
          <div />
        )}
        {thirdButton ? (
          <a onClick={hide ? undefined : onClickThird} className={styles.secondButton}>
            {thirdButton}
          </a>
        ) : (
          <div />
        )}
        {additionalOptions?.length ? (
          additionalOptions.map((o, i) => {
            return (
              <a key={"add_op_" + i} onClick={hide ? undefined : o.onClick} className={styles.secondButton}>
                {o.label}
              </a>
            );
          })
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  }
}
